import LoadingImage from 'components/LoadingImage/LoadingImage';
import withWindowState, { WithWindowState } from 'enhancers/withWindowState';
import * as React from 'react';
import styled from 'styled-components';
import Section from 'wrappers/Section/Section';

interface IProps {
  loading: boolean;
  images?: string[];
  className?: string;
}

const defaultItems = ['', '', '', ''];

const createItem = (loading: boolean, height: number) => (
  src: string,
  key: number
) => (
  <ImageContainer style={loading ? { height } : {}} key={key}>
    <Image src={src} loading={loading} />
  </ImageContainer>
);

type Props = IProps & WithWindowState;

export const SponsorSection: React.SFC<Props> = props => (
  <Section className={props.className}>
    <Container>
      {props.images && !props.loading
        ? props.images.map(
            createItem(props.loading, props.window.width > 750 ? 170 : 75)
          )
        : defaultItems.map(
            createItem(props.loading, props.window.width > 750 ? 170 : 75)
          )}
    </Container>
  </Section>
);

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  @media (max-width: 1300px) {
    justify-content: space-around;
  }
  @media (max-width: 750px) {
    justify-content: space-around;
  }
`;

const ImageContainer = styled.div`
  width: 170px;
  padding: 15px 0;
  @media (max-width: 750px) {
    width: 75px;
  }
`;

const Image = styled(LoadingImage)`
  width: 100%;
  opacity: 0.5;
  filter: grayscale(1);
`;

export default withWindowState(SponsorSection);



// WEBPACK FOOTER //
// ./src/components/SponsorSection/SponsorSection.tsx